import React, { useState, useEffect, useCallback } from 'react';
import api from '../api/axios';

const DeleteAccountRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRequests = useCallback(async () => {
    try {
      const res = await api.get('/users/admin/delete-requests');
      if (res.data.success) {
        setRequests(res.data.data);
      }
    } catch (err) {
      alert('Failed to fetch delete requests');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);


  const handleApprove = async (id) => {
    if (!window.confirm('Are you sure you want to approve this request? The user account will be permanently deleted.')) return;
    
    try {
      const res = await api.put(`/users/admin/delete-requests/${id}/approve`);
      if (res.data.success) {
        alert('Account deleted successfully');
        fetchRequests(); // Refresh the list
      }
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to approve request');
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">
        Delete Account Requests
      </h2>

      {loading ? (
        <div className="text-center py-10 text-gray-600">Loading requests...</div>
      ) : requests.length === 0 ? (
        <div className="p-6 rounded-lg text-center bg-white shadow text-gray-500">
          No pending account deletion requests found.
        </div>
      ) : (
        <div className="rounded-xl shadow-lg overflow-hidden bg-white">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-100 text-gray-600">
                  <th className="p-4 border-b border-gray-200 font-semibold">User</th>
                  <th className="p-4 border-b border-gray-200 font-semibold">Reason</th>
                  <th className="p-4 border-b border-gray-200 font-semibold">Date</th>
                  <th className="p-4 border-b border-gray-200 font-semibold">Status</th>
                  <th className="p-4 border-b border-gray-200 font-semibold text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((request) => (
                  <tr key={request._id} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="p-4">
                      {request.userId ? (
                        <>
                          <div className="font-medium text-gray-900">{request.userId.name}</div>
                          <div className="text-sm text-gray-500">{request.userId.email}</div>
                          <div className="text-xs text-gray-400 mt-1 capitalize">{request.userId.role}</div>
                        </>
                      ) : (
                        <div className="text-sm text-red-500 italic">User data missing (Already deleted)</div>
                      )}
                    </td>
                    <td className="p-4">
                      <div className="text-sm text-gray-700 max-w-xs break-words">
                        {request.reason || 'No reason provided'}
                      </div>
                    </td>
                    <td className="p-4 text-sm text-gray-500">
                      {new Date(request.createdAt).toLocaleDateString()}
                    </td>
                    <td className="p-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                        request.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
                        request.status === 'APPROVED' ? 'bg-green-100 text-green-800' :
                        'bg-red-100 text-red-800'
                      }`}>
                        {request.status}
                      </span>
                    </td>
                    <td className="p-4 text-center">
                      {request.status === 'PENDING' && request.userId && (
                        <button
                          onClick={() => handleApprove(request._id)}
                          className="px-3 py-1 bg-red-600 hover:bg-red-700 text-white rounded text-sm transition flex items-center justify-center gap-2 mx-auto"
                          title="Approve Deletion"
                        >
                          <span className="material-symbols-outlined text-[14px]">check_circle</span> Approve Deletion
                        </button>
                      )}
                      {request.status === 'APPROVED' && (
                        <span className="text-green-500 text-sm flex items-center justify-center gap-1">
                          <span className="material-symbols-outlined text-[14px]">check_circle</span> Deleted
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAccountRequests;
